// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 5064 ? "virtualhousesim" : chunkId) + "." + {"3630":"4b058fd6","5064":"e7672558","7873":"24565726"}[chunkId] + ".chunk.css";
};